/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Pump_UnknownInputs */

const vi_irrigation_devices_pump_unknown = /** @type {(inputs: Irrigation_Devices_Pump_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không rõ`)
};

/**

* @param {Irrigation_Devices_Pump_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_pump_unknown = /** @type {((inputs?: Irrigation_Devices_Pump_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Pump_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_pump_unknown(inputs)
});